(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-our-experts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.meet-experts');

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-expert-track]');
      const viewport = carousel.querySelector('.meet-experts__carousel-viewport');
      const prevBtn = carousel.querySelector('[data-expert-prev]');
      const nextBtn = carousel.querySelector('[data-expert-next]');
      const mobilePrevBtn = carousel.querySelector('[data-expert-mobile-prev]');
      const mobileNextBtn = carousel.querySelector('[data-expert-mobile-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-expert-dot]'));

      if (!track || !viewport) return;

      const cards = Array.from(carousel.querySelectorAll('[data-expert-card][data-clone="false"]'));
      if (cards.length === 0) return;

      let currentIndex = 0;
      let isTransitioning = false;

      function getGap() {
        return window.innerWidth < 750 ? 8 : 16;
      }

      // Duplicate cards for infinite loop
      function setupInfiniteLoop() {
        // Clear existing clones
        const clones = track.querySelectorAll('[data-clone="true"]');
        clones.forEach((c) => c.remove());

        // Add 3 sets: ...cards, cards, cards...
        const fragment1 = document.createDocumentFragment();
        const fragment2 = document.createDocumentFragment();

        cards.forEach((card) => {
          const clone1 = card.cloneNode(true);
          const clone2 = card.cloneNode(true);
          clone1.setAttribute('data-clone', 'true');
          clone2.setAttribute('data-clone', 'true');
          clone1.removeAttribute('id');
          clone2.removeAttribute('id');
          fragment1.appendChild(clone1);
          fragment2.appendChild(clone2);
        });

        // Prepend and append
        track.insertBefore(fragment1, track.firstChild);
        track.appendChild(fragment2);

        // Start at middle set, second card on mobile
        const isMobile = window.innerWidth < 750;
        currentIndex = cards.length + (isMobile ? 1 : 0);
        updatePosition(false);
      }

      function updatePosition(animate = true) {
        const cardWidth = cards[0].getBoundingClientRect().width;
        const gap = getGap();
        const isMobile = window.innerWidth < 750;
        const viewportWidth = viewport.getBoundingClientRect().width;

        // On mobile, offset to center the current card inside the actual visible viewport.
        const viewportCenter = isMobile ? (viewportWidth - cardWidth) / 2 : 0;
        const offset = currentIndex * (cardWidth + gap) - viewportCenter;

        if (animate) {
          track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0.0, 0.2, 1)';
        } else {
          track.style.transition = 'none';
        }

        track.style.transform = `translateX(-${offset}px)`;
      }

      function getRealIndex() {
        return (((currentIndex - cards.length) % cards.length) + cards.length) % cards.length;
      }

      function updateDots() {
        if (window.innerWidth >= 750) return;
        const real = getRealIndex();
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === real));
      }

      function scrollTo(direction) {
        if (isTransitioning) return;
        isTransitioning = true;

        currentIndex += direction;
        updatePosition(true);

        setTimeout(() => {
          // Check if we need to loop
          if (currentIndex >= cards.length * 2) {
            currentIndex = cards.length;
            updatePosition(false);
          } else if (currentIndex < cards.length) {
            currentIndex = cards.length * 2 - 1;
            updatePosition(false);
          }

          updateDots();
          isTransitioning = false;
        }, 500);
      }

      function goToDot(targetRealIndex) {
        if (isTransitioning) return;
        const delta = targetRealIndex - getRealIndex();
        if (delta === 0) return;
        isTransitioning = true;
        currentIndex += delta;
        updatePosition(true);
        setTimeout(() => {
          if (currentIndex >= cards.length * 2) {
            currentIndex -= cards.length;
            updatePosition(false);
          } else if (currentIndex < cards.length) {
            currentIndex += cards.length;
            updatePosition(false);
          }
          updateDots();
          isTransitioning = false;
        }, 500);
      }

      setupInfiniteLoop();
      updateDots();

      // Dot controls
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => goToDot(i));
      });

      // Button controls
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          scrollTo(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          scrollTo(1);
        });
      }

      if (mobilePrevBtn) {
        mobilePrevBtn.addEventListener('click', () => {
          scrollTo(-1);
        });
      }

      if (mobileNextBtn) {
        mobileNextBtn.addEventListener('click', () => {
          scrollTo(1);
        });
      }

      // Pause on hover
      carousel.addEventListener('mouseenter', () => {
        isPaused = true;
      });
      carousel.addEventListener('mouseleave', () => {
        isPaused = false;
      });

      // Touch/swipe gestures for mobile
      let touchStartX = 0;
      let touchEndX = 0;

      carousel.addEventListener(
        'touchstart',
        (e) => {
          touchStartX = e.changedTouches[0].screenX;
          isPaused = true;
        },
        { passive: true }
      );

      carousel.addEventListener(
        'touchend',
        (e) => {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
          isPaused = false;
        },
        { passive: true }
      );

      function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > swipeThreshold) {
          if (diff > 0) {
            // Swiped left - go forward
            scrollTo(1);
          } else {
            // Swiped right - go backward
            scrollTo(-1);
          }
        }
      }

      // Handle resize
      window.addEventListener('resize', () => {
        setupInfiniteLoop();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.review-highlights');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var track = section.querySelector('[data-review-track]');
      if (!track) return;

      var cards = Array.prototype.slice.call(section.querySelectorAll('.review-highlights__card'));
      if (!cards.length) return;

      var images = Array.prototype.slice.call(section.querySelectorAll('.review-highlights__image-item'));

      var prevButton = section.querySelector('[data-review-prev]');
      var nextButton = section.querySelector('[data-review-next]');
      var index = 0;
      var cardWidth = 0;

      function measureCardWidth() {
        if (!cards.length) return;
        if (cards.length >= 2) {
          // Measure the actual slide distance (card width + gap) from the DOM
          var r0 = cards[0].getBoundingClientRect();
          var r1 = cards[1].getBoundingClientRect();
          cardWidth = r1.left - r0.left;
        } else {
          cardWidth = cards[0].getBoundingClientRect().width;
        }
      }

      function applyOffset() {
        if (!cardWidth) {
          measureCardWidth();
        }

        var offset = -index * cardWidth;
        track.style.transform = 'translateX(' + offset + 'px)';
      }

      function updateButtons() {
        if (!prevButton || !nextButton) return;

        var total = cards.length;

        if (total <= 1) {
          prevButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        if (index <= 0) {
          prevButton.disabled = true;
          nextButton.disabled = false;
        } else if (index >= total - 1) {
          prevButton.disabled = false;
          nextButton.disabled = true;
        } else {
          prevButton.disabled = false;
          nextButton.disabled = false;
        }
      }

      function setActive(newIndex) {
        var total = cards.length;
        if (newIndex < 0 || newIndex >= total) return;
        index = newIndex;
        applyOffset();

        cards.forEach(function (card, i) {
          if (i === index) {
            card.classList.add('is-active');
          } else {
            card.classList.remove('is-active');
          }
        });

        images.forEach(function (image, i) {
          if (i === index) {
            image.classList.add('is-active');
          } else {
            image.classList.remove('is-active');
          }
        });

        updateButtons();
      }

      measureCardWidth();
      applyOffset();
      updateButtons();

      window.addEventListener('resize', function () {
        measureCardWidth();
        applyOffset();
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          setActive(index - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          setActive(index + 1);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
